import React from 'react';

interface LandingCardProps {
    imageSrc: string;
    title: string;
    description: string;
}

const LandingCard: React.FC<LandingCardProps> = ({ imageSrc, title, description }) => {
    return (
        <div
            data-testid="landing-card"
            className="group bg-white rounded-2xl border border-gray-100 shadow-sm p-7 w-full text-center
        hover:shadow-md hover:border-blue-100 transition-all duration-200 flex flex-col items-center"
        >
            <div className="bg-blue-50 rounded-xl p-3 w-fit mb-5 group-hover:bg-blue-100 transition-colors">
                <img
                    src={imageSrc}
                    alt={title}
                    className="h-10 w-10 object-contain"
                />
            </div>
            <h3 className="text-base font-bold text-crumbblue mb-2">{title}</h3>
            <p className="text-gray-500 text-sm leading-relaxed">{description}</p>
        </div>
    );
};

export default LandingCard;